import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, Grid, Button, Spinner, Flex, useToast, useColorModeValue, Icon, Badge } from '@chakra-ui/react';
import { FaPlay, FaCheckCircle, FaBrain } from 'react-icons/fa';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import QuizLeaderboard from '../components/UserComponents/QuizLeaderboard';

const LnaQuizzes = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  const toast = useToast();
  const navigate = useNavigate();

  const cardBg = useColorModeValue("white", "var(--bg-surface, #161428)");
  const textDark = useColorModeValue("#0a2628", "var(--text-main, #EDE9FF)");
  const textMuted = useColorModeValue("#7a9c9f", "var(--text-muted, #9B98BC)");

  useEffect(() => {
    fetchQuizzes();
  }, []);

  const fetchQuizzes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/standalone-quiz`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setQuizzes(res.data);
    } catch (err) {
      toast({ title: 'Error fetching quizzes', status: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Flex justify="center" p={10}><Spinner size="xl" /></Flex>;
  }

  return (
    <Box p={6}>
      <Flex align="center" gap={3} mb={6}>
        <Box p={3} bg="purple.50" borderRadius="2xl" color="purple.600">
          <FaBrain size={24} />
        </Box>
        <Box>
          <Heading size="lg" fontWeight="900" color={textDark}>LNA Quizzes</Heading>
          <Text fontSize="sm" color={textMuted} fontWeight="600">
            Take these standalone quizzes to identify your knowledge gaps and update your Learning Needs Analysis.
          </Text>
        </Box>
      </Flex>

      {quizzes.length === 0 ? (
        <Text color={textMuted}>No quizzes available for your department.</Text>
      ) : (
        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6}>
          {quizzes.map((quiz) => (
            <Box key={quiz._id} p={6} bg={cardBg} borderRadius="2xl" boxShadow="sm" border="1px solid rgba(255,255,255,0.05)">
              <Flex justify="space-between" mb={4}>
                <Badge colorScheme={quiz.isCompleted ? "green" : "blue"} borderRadius="full" px={3} py={1}>
                  {quiz.isCompleted ? "Completed" : "New"}
                </Badge>
                <Text fontSize="xs" color={textMuted} fontWeight="800">{quiz.department}</Text>
              </Flex>
              
              <Heading size="md" mb={2} color={textDark}>{quiz.title}</Heading>
              <Text fontSize="sm" color={textMuted} mb={6}>{quiz.questionsCount} Questions</Text>
              
              <Button
                w="full"
                colorScheme={quiz.isCompleted && !quiz.allowRetake ? "green" : "purple"}
                leftIcon={quiz.isCompleted && !quiz.allowRetake ? <FaCheckCircle /> : <FaPlay />}
               onClick={() => navigate(quiz.isCompleted && !quiz.allowRetake  ? `/lna-quiz/${quiz._id}/result` : `/lna-quiz/${quiz._id}`)}
               isDisabled={quiz.isCompleted && !quiz.allowRetake}
              >
                {quiz.isCompleted && !quiz.allowRetake ? "Already Taken" : quiz.isCompleted ? "Retake Quiz" : "Start Quiz"}
              </Button>
            </Box>
          ))}
        </Grid>
      )}

      <Box mt={10}>
        <QuizLeaderboard />
      </Box>
    </Box>
  );
};

export default LnaQuizzes;
